import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WebapiService } from '../shared/services/webapi.service';
import { ToastrService } from 'ngx-toastr';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-invite-signup',
  templateUrl: './invite-signup.component.html',
  styleUrls: ['./invite-signup.component.scss']
})
export class InviteSignupComponent implements OnInit {
  invite_code="";
  formSubmitting=false;
  invitation:any;

  coachForm: FormGroup = this.fb.group({
    password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
    agree: ["", Validators.compose([Validators.required])]
  });

  constructor(private route: ActivatedRoute, private fb: FormBuilder, public webApi: WebapiService, private toastrService: ToastrService, public router: Router) {

  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.invite_code = params['invite_code'];
        this.getInvitationData(this.invite_code);
      }
    );
  }

  getInvitationData(invitecode){
    this.webApi.getInvitationData({invite_code:invitecode}).subscribe((data: any) => {
      if(data.success){
        this.invitation=data.data
      }else{
        this.toastrService.error(data.message);
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }

  onSigup(form: FormGroup) {
    if (form.valid && !this.formSubmitting) {
      this.formSubmitting=true;
      form.value.invite_code = this.invite_code
      this.webApi.invitationSignup(form.value).subscribe((data: any) => {
        if (data.success) {
          form.reset();
					this.toastrService.success(data.message);
          this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.formSubmitting=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.formSubmitting=false;
      });
    } else {
      this.webApi.validateAllFields(form);
    }
  }
  
  get f1(): { [key: string]: AbstractControl } {
    return this.coachForm.controls;
  }

}
